// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qmzVBufRhiYnV1rLzc4O{flex-direction:column;gap:4px;display:flex}.qmzVBufRhiYnV1rLzc4O .QJasGjonoAJSDnefGd4z{margin-top:20px;padding:12px;font-size:14px;font-weight:400;line-height:20px}.qmzVBufRhiYnV1rLzc4O .QJasGjonoAJSDnefGd4z.IgGdgiAyAc70Cnf80BVD{margin-bottom:4px}.qmzVBufRhiYnV1rLzc4O .ScomvmILskUOKlqloFES{margin:14px 0 3px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `qmzVBufRhiYnV1rLzc4O`,
	"textField": `QJasGjonoAJSDnefGd4z`,
	"error": `IgGdgiAyAc70Cnf80BVD`,
	"wrapResend": `ScomvmILskUOKlqloFES`
};
export default ___CSS_LOADER_EXPORT___;
